/**
 * 강의 카드에 쓸 썸네일 주소.
 *
 * 서버가 만든 목록용 작은 판(`thumbnail_small_url`, 폭 720px JPEG, 대개 100KB 안팎)이
 * 있으면 그것, 없으면 원본(`thumbnail_url`). 원본은 관리자가 올린 그대로(1.4~7.5MB)라
 * 목록 카드가 수 초씩 걸려 떴다. 작은 판은 업로드한 썸네일에서만 만들어진다 —
 * SVG · Vimeo 기본 썸네일이면 없다.
 */
export const pickThumbnail = (
  info?: { thumbnail_url?: string | null; thumbnail_small_url?: string | null } | null,
): string => info?.thumbnail_small_url || info?.thumbnail_url || '';
